<div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">
        Allocate group to product
    </h5>
    <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="close()">
        <span aria-hidden="true">Close</span>
    </button>
</div>

<div class="modal-body container modal-content" ngbAutofocus>
    <form [formGroup]="form">
        <div class="pool-name-container d-flex justify-content-center align-items-center">
            <app-dc-input
                    label="Product ID"
                    id="product-id"
                    type="text"
                    formControlName="productId">
            </app-dc-input>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-primary"
            (click)="confirm()"
            [disabled]="form.invalid">
        Confirm
    </button>
</div>